/**
 * Display primitive data and allow user modification.
 */
export const EditableCell = (): JSX.Element => <div />;
